module.exports = __webpack_public_path__ + "static/media/blanket.1eb4deef.svg";